<basket-supplier-item-ui
    [companySetting]="companySetting"
    [supplierBasketItem]="supplierItem$ | async"
    [parentSBId]="parentSBId"
    [isEditableStep]="isEditableStep"
    [companyCodeId]="companyCodeId"
    [resolvedPurchasingGroups]="resolvedPurchasingGroups"
    [purchasingGroupVisible]="purchasingGroupVisible"
    (basketQuantityUpdated)="updateBasketQuantity($event)"
    (basketItemDeleted)="deleteBasketItem($event)"
    (accountingSelected)="changeAccounting($event)"
    (classificationSelected)="changeClassification($event)"
    (materialGroupSelected)="changeMaterialGroup($event)"
    (attachmentFileBasketItemDeleted)="deleteBasketItemAttachmentFile($event)"
    (attachmentBasketItemOpened)="openAttachmentBasketItemDialog($event)"
    (articleNumberUpdated)="updateProductNumber($event)"
    (productNumberValidationMessageShowed)="onShowProductNumberValidationMessage($event)"
    (desiredDeliveryDateValidated)="onDesiredDeliveryDateValidated($event)"
    (desiredDeliveryDateUpdated)="updateDesiredDeliveryDate($event)"
    (productDialogOpened)="openProductDialog($event)"
    (internalPositionNoteSent)="sendInternalPositionNote($event)"
    (siteSelected)="changeSite($event)"
    (siteValidated)="onSiteValidated($event)"
    (accountingValidated)="onAccountingValidated($event)"
    (classificationValidated)="onClassificationValidated($event)"
    (materialGroupValidated)="onMaterialGroupValidated($event)"
></basket-supplier-item-ui>
